"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberToCurrency = exports.formatPercent = void 0;
/**
 * Convert a number to a string with a locale.
 * @internal
 *
 * @param style - The type of format to convert to.
 * @param fractions - The number of decimal places to use.
 * @param value - The number to convert.
 *
 * @returns Number with the format.
 *
 * @example
 * ```ts
 * const result = numberToLocaleString(123.45, 'currency', 2);
 * console.log(result);
 * // => '$123.45'
 * ```
 */
function numberToLocaleString(style, fractions, value) {
    return value.toLocaleString('en-US', {
        style,
        currency: 'USD',
        minimumFractionDigits: fractions,
        maximumFractionDigits: fractions,
    });
}
/**
 * Convert a number to a currency format.
 *
 * @param value - The number to convert.
 * @param intOnly - Flag to round the value and show value without decimals.
 *
 * @returns Number with currency format.
 *
 * @example
 * ```ts
 * const result = numberToCurrency(123.45, true);
 * console.log(result);
 * // => '$123'
 * ```
 */
function numberToCurrency(value, intOnly = true) {
    return numberToLocaleString('currency', intOnly ? 0 : 2, value);
}
exports.numberToCurrency = numberToCurrency;
/**
 * Convert a number to a percentage format.
 *
 * @param value - The number to convert.
 * @param intOnly - Flag to round the value and show value without decimals.
 *
 * @returns Number with percent format.
 *
 * @example
 * ```ts
 * const result = numberToPercent(0.12345, true);
 * console.log(result);
 * // => '12%'
 * ```
 */
function formatPercent(value, intOnly = true) {
    return numberToLocaleString('percent', intOnly ? 0 : 2, value);
}
exports.formatPercent = formatPercent;
//# sourceMappingURL=number-to-locale-string.js.map